/// <amd-module name="Wit/LinkedWorkItemsDropdown/Components/WorkItemState" />
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import { CoreFieldRefNames } from "Wit/Common/Generated/Constants";
import { getLinkedWorkItemsService } from "Wit/LinkedWorkItemsDropdown/LinkedWorkItemsService";
import { WorkItemStateProvider } from "Wit/UI/Data";
import { WorkItemState as WorkItemStateInternal } from "Wit/UI/WorkItemState";
import { IWorkItemStateProps } from "./ControlledLinkedWorkItemsDropdown.Props";

export class WorkItemState extends VssComponent<IWorkItemStateProps> {
    public render() {
        const { workItem } = this.props;

        return (
            <WorkItemStateProvider
                dataProvider={getLinkedWorkItemsService(this.context.pageContext).getDataProvider()}
                dataSource={{
                    projectIdOrName: workItem.fields[CoreFieldRefNames.TeamProject],
                    workItemTypeName: workItem.fields[CoreFieldRefNames.WorkItemType],
                    stateName: workItem.fields[CoreFieldRefNames.State]
                }}
            >
                {stateAndColor => <WorkItemStateInternal data={stateAndColor} hideText={false} />}
            </WorkItemStateProvider>
        );
    }
}
